import React, { Fragment } from 'react';
import { Route } from 'react-router-dom';

const NavigationRoutes = ({ config }) => (
  <Fragment>
    {config
      .filter(({ path, external, component }) => path && component && !external)
      .map(({ path, exact, component }, i) => (
        <Route key={i} path={path} exact={exact} component={component} />
      ))}
  </Fragment>
);

export default NavigationRoutes;
